module.exports = __webpack_public_path__ + "static/media/Command_Management_System_01.8e108520.jpg";